import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import ListeningTextLogo from '../ListeningTextLogo';
import { twMerge } from 'tailwind-merge';
import { CommonLink } from '../../views/common/CommonLink';

const ListeningTermsLayout = observer(() => {
    return (
        <div className="bg-base-100 mx-auto max-w-[1000px]">
            <header
                className={twMerge(
                    'border-base-content/10 bg-base-100 sticky top-0 z-10 flex flex-row flex-wrap items-center gap-x-8 gap-y-0 px-4',
                    'h-24',
                )}
            >
                <div className="flex h-6 w-20 shrink-0 items-center">
                    <ListeningTextLogo />
                </div>
                <div className="flex h-6 items-center gap-4">
                    <CommonLink
                        to="/terms"
                        className="text-base-content/80 link link-hover text-sm"
                    >
                        이용약관
                    </CommonLink>
                    <CommonLink
                        to="/privacy"
                        className="text-base-content/80 link link-hover text-sm"
                    >
                        개인정보처리방침
                    </CommonLink>
                    <CommonLink
                        to="/license"
                        className="text-base-content/80 link link-hover text-sm"
                    >
                        오픈소스 라이선스
                    </CommonLink>
                </div>
            </header>
            <Outlet />
        </div>
    );
});

export default ListeningTermsLayout;
